import { getTestIdProp } from '@ab-core/testing';
import Text from '@ab-core/text';
import type { FC } from 'react';
import React from 'react';

type PackagingSizeType = { isVisible?: boolean; packagingSize: string | number };

export const PackagingSize: FC<PackagingSizeType> = (props) => {
    const { isVisible, packagingSize } = props;

    if (!isVisible) {
        return <div style={{ height: '0px' }}></div>;
    }

    return (
        <div>
            <div className="flex-justify-content-space-between" {...getTestIdProp('product-card-packaging-size')}>
                <Text>Verpackungseinheit</Text>
                <Text>{packagingSize ? packagingSize : '-'}</Text>
            </div>
        </div>
    );
};
